import { OkCircleIcon, spacing, StatusMessage } from '@rulebooks/evidend-titan';
import { GlobalSuccessMessages } from 'components/GlobalSuccess/GlobalSuccessMessages';
import { AnimatePresence, motion } from 'framer-motion';
import { useGlobalSuccess } from 'hooks/useGlobalSuccess';
import React from 'react';
import styled from 'styled-components';

const slideFadeBottom = {
  initial: { y: '40px', opacity: 0 },
  animate: { y: '0', opacity: 1 },
  exit: { y: '40px', opacity: 0 },
};

const Floating = styled(motion.div)`
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  padding: ${spacing(6)};

  width: 100%;
  max-width: 640px;

  z-index: 1000000;
`;

export const GlobalSuccess = () => {
  const [messages, setMessages] = useGlobalSuccess();

  return (
    <AnimatePresence>
      {messages && (
        <Floating {...slideFadeBottom}>
          <StatusMessage
            defaultIsShown
            isCloseable
            isRounded
            isShown
            alignment="left"
            icon={<OkCircleIcon />}
            type="success"
            onClose={() => setMessages(undefined)}
          >
            {typeof messages === 'string' ? (
              messages
            ) : (
              <GlobalSuccessMessages messages={messages} />
            )}
          </StatusMessage>
        </Floating>
      )}
    </AnimatePresence>
  );
};
